export default function TrekIncluded({ included, excluded }) {
  return (
    <div style={{ 
      marginBottom: '60px', 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
      gap: '40px' 
    }}>
      <div>
        <h2 className="section-title" style={{ fontSize: '24px', marginBottom: '24px' }}>What's included.</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {included && included.map(i => (
            <li key={i} style={{ 
              fontSize: '13px', 
              color: 'var(--ink-mid)', 
              marginBottom: '14px', 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px' 
            }}>
              <div style={{ 
                width: '18px', height: '18px', borderRadius: '50%', 
                background: 'var(--green-light)', display: 'flex', 
                alignItems: 'center', justifyContent: 'center', flexShrink: 0 
              }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="var(--green)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              {i}
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h2 className="section-title" style={{ fontSize: '24px', marginBottom: '24px' }}>What's NOT included.</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {excluded && excluded.map(e => (
            <li key={e} style={{ 
              fontSize: '13px', 
              color: 'var(--ink-mid)', 
              marginBottom: '14px', 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px', 
              opacity: 0.8 
            }}>
              <div style={{ 
                width: '18px', height: '18px', borderRadius: '50%', 
                background: '#fef2f2', display: 'flex', 
                alignItems: 'center', justifyContent: 'center', flexShrink: 0 
              }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
              {e}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
